(function (window, document) {
  console.log("MVT Engine: Preview module loaded");

  const Utils = window.MVTUtils;

  const Application = window.MVTApplicationModule;

  const PREVIEW = {
    fetchChangesAndApply: async function (PUBLIC_API_BASE) {
      if (!PUBLIC_API_BASE) {
        throw new Error("MVT Engine: Missing Public API base endpoint.");
      }

      const [preview_project, preview_id] = Utils.getKeysFromUrl(["preview_project", "preview_id"]);
      if (!preview_project || !preview_id) {
        throw new Error("MVT Engine: Missing project ID or variant/combination ID.");
      }

      const tokenPayload = await Utils.getTokenForPublicVariantEndpoints(
        PUBLIC_API_BASE,
        preview_project,
      );
      const bearerToken = tokenPayload?.response?.token || tokenPayload?.token || null;
      console.log("MVT Engine: Token response JSON (success)", tokenPayload);

      if (!bearerToken) {
        throw new Error("MVT Engine: Token missing from response.");
      }

      const changesUrl = `${PUBLIC_API_BASE}/preview/${preview_id}`;
      const changesOptions = {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
          Authorization: `Bearer ${bearerToken}`,
        },
      };

      console.log("MVT Engine: Preview request", {
        url: changesUrl,
        options: {
          ...changesOptions,
          headers: {
            ...changesOptions.headers,
            Authorization: "Bearer ***redacted***",
          },
        },
      });

      const changesResponse = await fetch(changesUrl, changesOptions);
      console.log("MVT Engine: Preview response meta", {
        status: changesResponse.status,
        ok: changesResponse.ok,
        redirected: changesResponse.redirected,
        type: changesResponse.type,
        url: changesResponse.url,
      });

      if (!changesResponse.ok) {
        let errorBody = null;
        try {
          errorBody = await changesResponse.text();
        } catch (e) {}
        console.error("MVT Engine: Preview response body (error)", errorBody);
        throw new Error(`Preview HTTP error! status: ${changesResponse.status}`);
      }

      const changesPayload = await changesResponse.json();
      const changes = changesPayload?.response || changesPayload;
      console.log("MVT Engine: Preview response JSON (success)", {
        count: changes.length,
        payload: changesPayload,
      });

      await Application.applyChanges(changes ? [changes] : []);
    },
  };

  window.MVTPreviewModule = PREVIEW;
})(window, document);
